import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { OperationalNotesContribution } from '../../../../../components/widgets/shared/notes/operational-notes-contribution/operational-notes-contribution';
import { connectNLP } from '../../../../../utilities/connect-navigate';
import { Contributions } from '../contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class NoteContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/airportoperationalnotes/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'notes';
	}

	public getModalEndpoint() {
		return `/airportoperationalnotes/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<OperationalNotesContribution
				endpoint={'/airportoperationalnotes/merge'}
				original={get(ctx.state, 'response')}
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				close={() => this.onModalClose()}
			/>
		);
	}
}

export const NoteContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(NoteContributionsComponent));
